module.exports = __webpack_public_path__ + "4ad587512c55422e03641c264e17a010.svg";